import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-white py-10 sm:py-14" data-id="element-158" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-159" data-mp="1t8niy08x17ou">
        <h2 className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-160" data-mp="1oac9hqmj8z75">
          <span aria-hidden="true" data-id="element-161" data-mp="1jb92w1qwmkx2">📊 </span>Zahlen lügen nicht
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-y-8 md:grid-cols-4 md:gap-y-0" data-id="element-162" data-mp="1ecz99vktvsdk">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-ink/10' : ''}`} data-id="element-163" data-mp="19lg2zy04ju8n" data-mpi={index}>
              <dt className="sr-only" data-id="element-164" data-mp="10lt1lc7eaofl">{stat.label}</dt>
              <dd data-id="element-165" data-mp="10n46jfcku28a">
                <span className="block font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-166" data-mp="10jq09w0sl8vk">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-ink/50 sm:text-xs" data-id="element-167" data-mp="qnd852kwb32x">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}